import { Button, Popover, ActionList } from '@shopify/polaris';
import { useCallback } from 'react';
import { useState } from 'react';

const DropdownButton = ({ items, title, buttonProps }) => {
  const [active, setActive] = useState(false);

  const toggleActive = useCallback(() => setActive((active) => !active), []);

  const activator = (
    <Button onClick={toggleActive} disclosure {...buttonProps}>
      {title}
    </Button>
  );

  const actionListProps = items.length
    ? items[0].hasOwnProperty('title')
      ? { sections: items }
      : {
          items,
        }
    : {};

  return (
    <Popover active={active} activator={activator} autofocusTarget="first-node" onClose={toggleActive}>
      <ActionList actionRole="menuitem" {...actionListProps} />
    </Popover>
  );
};

export default DropdownButton;
